/**
 * Builds an ABSOLUTE same-origin return URL for hosted flows (wallet setup,
 * checkout, onboarding). The BE accepts only same-origin URLs, and BE
 * defaults can even target nonexistent routes — so the FE ALWAYS sends
 * explicit URLs built with this helper (fe-plan §2.3).
 *
 * @param route  FE route, e.g. '/wallet' or `organizations/${id}/finance`
 * @param marker return query markers, e.g. { setup: 'success' }
 */
export function buildReturnUrl(route: string, marker?: Record<string, string>) {
  const url = new URL(route, window.location.origin);
  for (const [key, value] of Object.entries(marker ?? {})) {
    url.searchParams.set(key, value);
  }
  return url.toString();
}
